var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',{staticClass:"customer-cell",attrs:{"title":_vm.params.value?.name}},[_c('label',{staticClass:"customer-cell__text"},[_vm._v(_vm._s(_vm.params.value?.name || ""))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }